import { ThemeSchema } from './schemas/themeSchema.js';
export const defaultTheme = ThemeSchema.parse({});
//# sourceMappingURL=Theme.js.map